<!-- eslint-disable vue/no-mutating-props -->
<template>
  <div>
    <b-overlay
        :show="__isOnLoad"
        variant="white"
        rounded
        opacity="0.70"
        spinner-variant="primary"
        spinner-small
      >
      <b-modal 
          v-model="showUploader"  
          centered
          modal-class="app-popup-shell"
          dialog-class="app-popup-dialog"
          content-class="app-popup-content"
          body-class="app-popup-body"
          :hide-footer= "true"
          size="xl"
          title="" header-class="app-popup-header"
          >
            <galerie-manager :__payload="dataUploaderPayload"></galerie-manager>
          </b-modal>

      <div class="editionPanel">
        <div class="row">
          <div class="col-lg-3 mediaColumn">
            <div class="mediaPanel">
              <div class="mediaPreview" @click="showUploader = true">
                <img :src="adminImageSrc" alt="Compte" class="previewImage" />
              </div>

              <b-button class="mediaButton" @click="showUploader = true" size="sm">
                {{ hasAdminImage ? 'Changer logo' : 'Ajouter logo' }}
              </b-button>

              <div class="mediaHint">Image du compte ou avatar utilisateur.</div>
            </div>
          </div>

          <div class="col-lg-9 fieldsColumn">
            <div class="row">
              <div class="col-md-4 formGroup">
                <label class="formLabel">Type utilisateur</label>
                <div class="selectorField">
                  <selector
                    _id="676c8c74590157a748c9c8ba"
                    :_parentItem="__item"
                    _warpper="type"
                    :_showTitle="false"
                    :_optionFilter="filterUserTypes"
                    _customCss="background-color:#F8FAFC; padding: 10px; border-radius: 12px; margin-bottom: 0;"
                  ></selector>
                </div>
              </div>

              <div class="col-md-8 formGroup">
                <label class="formLabel">Nom et prénom</label>
                <base-input
                  placeholder="Nom et prénom"
                  v-model="__item.name"
                  type = "string"
                  :error = "errorCtrl"
                >
                </base-input>
              </div>

              <div class="col-md-12 formGroup">
                <label class="formLabel">Poste</label>
                <base-input
                  placeholder="Poste"
                  v-model="__item.post"
                  type = "string"
                  :error = "errorCtrl"
                >
                </base-input>
              </div>

              <div class="col-md-4 formGroup">
                <label class="formLabel">Téléphone</label>
                <base-input
                  placeholder="Téléphone"
                  v-model="__item.tel"
                  type = "string"
                  :error = "errorCtrl"
                >
                </base-input>
              </div>

              <div class="col-md-4 formGroup">
                <label class="formLabel">CNSS</label>
                <base-input
                  placeholder="CNSS"
                  v-model="__item.cnss"
                  type = "string"
                  :error = "errorCtrl"
                >
                </base-input>
              </div>

              <div class="col-md-4 formGroup">
                <label class="formLabel">Email</label>
                <base-input
                  placeholder="Email"
                  v-model="__item.email"
                  type = "string"
                  :error = "errorCtrl"
                >
                </base-input>
                <small v-if="emailVerificationVerified" class="verificationState verificationStateSuccess">Adresse confirmée</small>
              </div>

              <div v-if="emailVerificationRequested" class="col-md-4 formGroup">
                <label class="formLabel">Code email</label>
                <base-input
                  placeholder="Code à 6 chiffres"
                  :value="emailVerificationCode"
                  maxlength="6"
                  inputmode="numeric"
                  autocomplete="one-time-code"
                  @input="$emit('update-email-verification-code', $event.replace(/\D/g, '').slice(0, 6))"
                  type="string"
                  :error="errorCtrl"
                ></base-input>
                <small class="verificationState">Valable encore {{ formattedVerificationRemaining }}</small>
              </div>

              <div class="col-md-4 formGroup verificationAction">
                <label class="formLabel">Vérification email</label>
                <b-button
                  block
                  size="sm"
                  variant="outline-primary"
                  :disabled="emailVerificationBusy || emailVerificationVerified"
                  @click="$emit('request-email-verification')"
                >
                  {{ emailVerificationRequested ? 'Renvoyer le code' : 'Envoyer le code' }}
                </b-button>
                <b-button
                  v-if="emailVerificationRequested"
                  block
                  size="sm"
                  variant="primary"
                  :disabled="emailVerificationBusy || emailVerificationCode.length !== 6"
                  @click="$emit('confirm-email-verification')"
                >
                  Confirmer le code
                </b-button>
              </div>

              <div class="col-md-6 formGroup">
                <label class="formLabel">Login</label>
                <base-input
                  placeholder="Login"
                  v-model="__item.login"
                  type = "string"
                  :error = "errorCtrl"
                >
                </base-input>
              </div>

              <div class="col-md-6 formGroup">
                <label class="formLabel">Mot de passe</label>
                <base-input
                  placeholder="Mot de passe"
                  v-model="__item.pwd"
                  type = "password"
                  :error = "errorCtrl"
                >
                </base-input>
              </div>
            </div>

            <div class="summaryCard">
              <div class="summaryHeader">Résumé compte</div>
              <div class="summaryBody">
                <div class="summaryMedia">
                  <img :src="adminImageSrc" alt="Compte" class="summaryImage" />
                </div>
                <div class="summaryInfo">
                  <div><b>Nom :</b> {{ __item.name || '-' }}</div>
                  <div><b>Type :</b> {{ __item.type || '-' }}</div>
                  <div><b>Poste :</b> {{ __item.post || '-' }}</div>
                </div>
                <div class="summaryInfo">
                  <div><b>Email :</b> {{ __item.email || '-' }}</div>
                  <div><b>Téléphone :</b> {{ __item.tel || '-' }}</div>
                  <div><b>Login :</b> {{ __item.login || '-' }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="actionBar">
          <div class="col-md-12">
            <b-button size="sm" variant="danger"  @click="dispatchCancel()"> Fermer </b-button>
            <b-button size="sm" variant="success" @click="dispatchSave()" v-if="(errorCtrl.filter(e => e.isValid === false).length === 0)">Enregistrer</b-button>
          </div>
        </div>
      </div>
    </b-overlay>
  </div>
</template>
<script>
import Vue from 'vue';

export default {
  components: {

  },
  props: {
    __isOnLoad: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    __item: {
      type: Object,
      default: () => {
        return {};
      },
    },
    emailVerificationRequested: {
      type: Boolean,
      default: false,
    },
    emailVerificationVerified: {
      type: Boolean,
      default: false,
    },
    emailVerificationCode: {
      type: String,
      default: '',
    },
    emailVerificationRemaining: {
      type: Number,
      default: 0,
    },
    emailVerificationBusy: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      _packID: [],
      fullList: [],
      showUploader: false,
      dataUploaderPayload: {
        folder: "prods",
        onFireCB: () => {},
        multiSelection: false,
        customClass: "customCatEditModal"
      },
      errorCtrl: [],
    }
  },
  computed: {
    adminImageSrc() {
      return this.getTof(this.__item.pic);
    },
    hasAdminImage() {
      return !!this.__item.pic;
    },
    formattedVerificationRemaining() {
      const minutes = Math.floor(this.emailVerificationRemaining / 60);
      const seconds = String(this.emailVerificationRemaining % 60).padStart(2, '0');
      return `${minutes}:${seconds}`;
    },
  },
  methods: {

    filterUserTypes(option) {
      const currentUser = Vue.$cookies.get('user');
      const optionRole = String(option.name || '').toUpperCase();
      if (optionRole === 'ROOT') return !!currentUser && currentUser.type === 'ROOT';
      if (optionRole === 'ADMIN') return !!currentUser && ['ADMIN', 'ROOT'].includes(currentUser.type);
      return true;
    },

    getTof(c) {
      return this.__.resolveMediaPath(c, 'uploads/users/No-Image.jpg');
      // return 'http://localhost:5000/uploads/'+c.split("/uploads/")[1];
      // return './uploads/'+c.split("/uploads/")[1];
    },

    dispatchSave() {
      this.$parent.saveAction();
    },
    dispatchCancel() {
      this.$parent.cancelAction();
    },


   

  },
  mounted() {
    
    this.dataUploaderPayload.clientID = '665d03b586d558945dfffa29';
    this.dataUploaderPayload.onFireCB = (params) => {
      this.showUploader = false
        this.__item.pic = params[0];
    }
  },

  watch: {
    
  },


};
</script>
<style scoped>
.editionPanel {
    width: 100%;
    padding: 20px;
    margin-bottom: 0;
    border-radius: 16px;
    background-color: #fff;
    box-shadow: 0 10px 28px rgba(15, 23, 42, 0.08);
}
.mediaColumn,
.fieldsColumn {
  margin-bottom: 12px;
}
.mediaPanel {
  height: 100%;
  min-height: 100%;
  padding: 14px;
  border-radius: 16px;
  background: linear-gradient(180deg, #f8fafc 0%, #eef2f7 100%);
  border: 1px solid #dbe4f0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.mediaPreview {
  min-height: 210px;
  border-radius: 14px;
  border: 1px dashed #cbd5e1;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  cursor: pointer;
}
.previewImage {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.mediaButton {
  background: #1f2a44;
  border-color: #1f2a44;
  color: #fff;
  font-weight: 600;
}
.mediaButton:hover,
.mediaButton:focus {
  background: #2f436d;
  border-color: #2f436d;
}
.mediaHint {
  font-size: 12px;
  line-height: 1.5;
  color: #64748b;
}
.formGroup {
  margin-bottom: 12px;
}
.formLabel {
  display: block;
  margin-bottom: 6px;
  font-size: 12px;
  font-weight: 700;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}
.verificationAction .btn + .btn {
  margin-top: 8px;
}
.verificationState {
  display: block;
  margin-top: 5px;
  font-size: 12px;
  color: #64748b;
}
.verificationStateSuccess {
  color: #198754;
  font-weight: 600;
}
.selectorField {
  width: 100%;
}
.summaryCard {
  margin-top: 6px;
  padding: 16px;
  border-radius: 16px;
  background: linear-gradient(180deg, #f8fafc 0%, #eef2f7 100%);
  border: 1px solid #dbe4f0;
}
.summaryHeader {
  margin-bottom: 12px;
  font-size: 12px;
  font-weight: 700;
  color: #475569;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}
.summaryBody {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  align-items: center;
}
.summaryMedia {
  width: 68px;
  height: 68px;
  border-radius: 14px;
  background: #fff;
  border: 1px solid #dbe4f0;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.summaryImage {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.summaryInfo {
  flex: 1 1 180px;
  font-size: 13px;
  color: #334155;
}
.summaryInfo div + div {
  margin-top: 4px;
}
.actionBar {
  margin-top: 12px;
  text-align: right;
}
.actionBar .btn + .btn {
  margin-left: 8px;
}
:deep(.modal-xl) {
  max-width: 85% !important;
}
.form-control option {
  color: black;
}
@media (max-width: 991px) {
  .editionPanel {
    padding: 16px;
  }
  .mediaPreview {
    min-height: 160px;
  }
  .summaryBody {
    flex-direction: column;
    align-items: flex-start;
  }
}
</style>

